<!--
单页面示例：字段较少、单列布局；

el-form用法参考：http://element-cn.eleme.io/#/zh-CN/component/form；
:class="$style['rp-wrapper']" 这是module css的用法；

-->
<template>
  <uploader :options="options"  @file-added="onFileAdded" @file-success="fileSuccess" class="uploader-example">
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
      <p>Drop files here to upload or</p>
      <uploader-btn>select files</uploader-btn>
      <uploader-btn :attrs="attrs">select images</uploader-btn>
      <!-- 
      <uploader-btn :directory="true">select folder</uploader-btn>
        -->
      </uploader-drop>
      <uploader-list></uploader-list>
 </uploader>
</template>
<script>
  import Vue from 'vue'
  import uploader from 'vue-simple-uploader'
  import SparkMD5 from 'spark-md5'
  import util from '../../../../libs/util'
  Vue.use(uploader);

  export default {
    name: 'fileUpload-test',
    data () {
        return {
        options: {
           headers: {
                        Authorization:"bearer "+util.token()
                  },
          target: '//'+util.apiBasePath+'/jpcp/uploader/chunk',
          testChunks: true,
          simultaneousUploads: 10,
          chunkSize: 1024 * 512,
          single:true,
          checkChunkUploadedByResponse: function (chunk, message) {
              let objMessage = JSON.parse(message);
              console.info(objMessage);
              if (objMessage.skipUpload) {
                     return true;
              }
           },
           },
        attrs: {
          accept: 'image/*'
        },
        fileStatusText : {
          success: '成功了',
          error: '出错了',
          uploading: '上传中',
          paused: '暂停中',
          waiting: '等待中'
        }
      }
    },
    methods: {
      fileSuccess (rootFile, file, message, chunk) {
           console.info(file.name);
           console.info(file.uniqueIdentifier);
         util.ajax.post("/jpcp/uploader/createFile",{
           fileName:file.name,
           meteId:file.uniqueIdentifier    
          }).then((res) => {
               console.info(res);
                if (res.data.meta.errCode == 0) {
                     
                }else{
                  
                }
              }).catch((e) => {
                
              })

             console.log('complete', rootFile, file, chunk)
      },
       statusSet:function(fileId,value ){

       },
       onFileAdded:function(file){
          this.computeMD5(file);
       },computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();
                // 文件状态设为"计算MD5"
                this.statusSet(file.id, 'md5');
                 console.log("file.id:"+file.id);
                //file["name"] ="122";
                file.pause();
                console.info(file["status"]);
                loadNext();
                fileReader.onload = (e => {
                    spark.append(e.target.result);
                        let md5 = spark.end();
                       //this.computeMD5Success(md5, file);
                        file.uniqueIdentifier = md5;
                        console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                          file.resume();
                });
                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };
                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            }
    }
  }
</script>
<style lang="scss">
  .uploader-example {
    width: 880px;
    padding: 15px;
    margin: 40px auto 0;
    font-size: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
  }
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/jpcp/file/fileUpload-test.vue